module.exports = __webpack_public_path__ + "img/mai.ad4992c3.png";